module.exports = __webpack_public_path__ + "img/yl3050.9cb95530.png";